export const REPORT_CHART_FEEDBACK_BASED_MEASURES = [
  'feedback-nps',
  'feedback-csat',
  'feedback-ces',
  'feedback-weighted-score',
  'feedback-sentiment-score',
];
